import { render, staticRenderFns } from "./AnnouncementBox.vue?vue&type=template&id=71a14b13&scoped=true"
import script from "./AnnouncementBox.vue?vue&type=script&lang=js"
export * from "./AnnouncementBox.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBox.vue?vue&type=style&index=0&id=71a14b13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a14b13",
  null
  
)

export default component.exports